import {defineMessages} from 'react-intl';

export default defineMessages({
  forgotPassword: {
    defaultMessage: 'Forgot password?',
    id: 'LandingPage.LoginSection.ForgotPassword',
  },
});
